/**
 * Day to Night Ride
 * Desktop: pins the section while scrolling. Scroll picks the phase, but the
 *          switch only happens in the gap when the rider is off-screen
 *          (each loop boundary), then the scenery crossfades quickly.
 * Mobile:  no scroll-jacking — plays the clips back to back (on "ended"),
 *          crossfading between them, looping the whole cycle.
 * Reduced motion: handled in CSS (static poster, videos hidden).
 */
(function () {
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileMq = window.matchMedia('(max-width: 749px)');

  function initSection(section) {
    if (section.dataset.dtnReady) return;
    section.dataset.dtnReady = 'true';
    if (reduceMq.matches) return;

    var pin = section.querySelector('.dtn-pin');
    var videos = Array.prototype.slice.call(section.querySelectorAll('.dtn-video'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('.dtn-dot'));
    var loopSeconds = parseFloat(section.dataset.loopSeconds) || 4;
    var count = videos.length;
    if (count < 2 || !pin) return;

    /* ---- Tweak these to taste ---- */
    var EASE = 0.2;   // fade speed (0.2 ≈ half a second; lower = slower)
    var SAFE = 0.15;  // seconds either side of a loop boundary where switching is allowed

    var target = videos.map(function (_, i) { return i === 0 ? 1 : 0; });
    var shown = target.slice();
    var wasVisible = videos.map(function () { return false; });
    var inView = false;
    var rafId = null;
    var committed = 0;     // desktop: phase currently shown
    var mobileIndex = 0;
    var restartIndex = null;

    function applyMode() {
      videos.forEach(function (v) {
        v.muted = true;
        v.playsInline = true;
        v.loop = !mobileMq.matches;
      });
    }
    applyMode();

    videos.forEach(function (v, i) { v.style.opacity = shown[i]; });
    dots.forEach(function (d, i) { if (i >= count) d.style.display = 'none'; });

    /* Desktop: scroll decides the phase, the rider gap decides when */
    function scrollTargets() {
      var rect = pin.getBoundingClientRect();
      var range = pin.offsetHeight - window.innerHeight;
      var progress = range > 0 ? Math.min(Math.max(-rect.top / range, 0), 1) : 0;
      var desired = Math.min(count - 1, Math.floor(progress * count));

      if (desired !== committed) {
        var t = videos[committed].currentTime % loopSeconds;
        if (t < SAFE || t > loopSeconds - SAFE) committed = desired;
      }

      for (var i = 1; i < count; i++) target[i] = i <= committed ? 1 : 0;
      return desired !== committed; // true = still waiting for the gap
    }

    /* Start the incoming clip at the same point in the loop */
    function syncTo(v, i) {
      var src = null;
      for (var j = 0; j < count; j++) {
        if (j !== i && wasVisible[j] && (!src || Math.abs(j - i) < Math.abs(src.idx - i))) {
          src = { v: videos[j], idx: j };
        }
      }
      if (src && v.readyState >= 1) {
        try { v.currentTime = src.v.currentTime % loopSeconds; } catch (e) {}
      }
    }

    function updatePlayback() {
      var topFull = 0;
      for (var j = count - 1; j >= 0; j--) {
        if (shown[j] >= 0.999) { topFull = j; break; }
      }
      videos.forEach(function (v, i) {
        var visible = inView && i >= topFull && shown[i] > 0.001;
        if (visible && !wasVisible[i]) {
          if (mobileMq.matches) {
            if (i === restartIndex || v.ended) {
              try { v.currentTime = 0; } catch (e) {}
              if (i === restartIndex) restartIndex = null;
            }
          } else {
            syncTo(v, i);
          }
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!visible && wasVisible[i]) {
          v.pause();
        }
        wasVisible[i] = visible;
      });
    }

    function updateDots() {
      if (!dots.length) return;
      var active = 0;
      for (var i = 0; i < count; i++) if (shown[i] > 0.5) active = i;
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
    }

    function frame() {
      rafId = null;
      var waiting = !mobileMq.matches && inView && scrollTargets();
      var moving = false;
      for (var i = 0; i < count; i++) {
        var diff = target[i] - shown[i];
        if (Math.abs(diff) > 0.001) {
          shown[i] += diff * EASE;
          moving = true;
        } else {
          shown[i] = target[i];
        }
        videos[i].style.opacity = shown[i];
      }
      updatePlayback();
      updateDots();
      if (moving || waiting) request();
    }

    function request() {
      if (rafId === null) rafId = requestAnimationFrame(frame);
    }

    /* Mobile: when the current clip finishes, crossfade to the next */
    videos.forEach(function (v, i) {
      v.addEventListener('ended', function () {
        if (!mobileMq.matches || i !== mobileIndex) return;
        mobileIndex = (mobileIndex + 1) % count;
        restartIndex = mobileIndex;
        for (var k = 1; k < count; k++) target[k] = k <= mobileIndex ? 1 : 0;
        request();
      });
    });

    var io = new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      request();
    }, { rootMargin: '200px 0px' });
    io.observe(section);

    window.addEventListener('scroll', function () {
      if (inView && !mobileMq.matches) request();
    }, { passive: true });
    window.addEventListener('resize', request);

    mobileMq.addEventListener('change', function () {
      applyMode();
      committed = 0;
      mobileIndex = 0;
      for (var k = 1; k < count; k++) target[k] = 0;
      request();
    });

    request();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-dtn-section]').forEach(initSection);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();